import React, { useState, useEffect, useRef } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import axios from "axios";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

const AutocompleteMultipleLookup = ({
  field,
  fieldName,
  formType,
  isCreate,
  isEdit,
  isShow,
  values,
  fieldErrors,
  onChange,
  value,
}) => {
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const dispatch = useDispatch();
  const fieldRef = useRef(null);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const endpoint = `${process.env.REACT_APP_APP_ENDPOINT}api/auth/getRecords/${field.relatedObject}?all=true`;

        const response = await axios.get(endpoint, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        });

        if (Array.isArray(response.data)) {
          let extractedOptions = response.data.map((item) => ({
            id: item.id,
            label:
              field.relatedObject === "User"
                ? `${item.name} (${item.email}) - ${item.temporaryRole}`
                : item.title,
          }));

          setOptions(extractedOptions);

          // Gestisci il valore iniziale
          if (value) {
            const selected = extractedOptions.filter((option) =>
              value.includes(option.id)
            );
            setSelectedOptions(selected);
          } else if (values && values[fieldName]) {
            const selected = extractedOptions.filter((option) =>
              values[fieldName].includes(option.id)
            );
            setSelectedOptions(selected);
          }
        }
      } catch (error) {
        console.error("Errore nella chiamata all'endpoint:", error);
      }
    };

    fetchOptions();
  }, [field, value, values, fieldName]);

  const handleSelectionChange = (event, newValue) => {
    setSelectedOptions(newValue);

    const newValueIdsString = JSON.stringify(newValue.map((item) => item.id));

    onChange(field.name, newValueIdsString);
  };

  // Funzione di filtraggio personalizzata
  const filterOptions = (options, { inputValue }) => {

    const normalizeString = (str) => {
      return str.toLowerCase().replace(/[\s,]+/g, ''); // Rimuovi spazi e virgole
    };

    const normalizedInput = normalizeString(inputValue);
    let optioni = options.filter((option) =>
      normalizeString(option.label).includes(normalizedInput)
    );
    console.log('optioni', optioni)
    return optioni
  };

  return (
    <Autocomplete
      sx={{ height: "50px" }}
      ref={fieldRef}
      multiple={true} // Abilita la selezione multipla
      options={options}
      filterOptions={filterOptions} // Applica il filtro personalizzato
      getOptionLabel={(option) => option.label}
      value={selectedOptions}
      onChange={handleSelectionChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Clicca per cercare"
          variant="standard"
          error={Boolean(fieldErrors)}
          helperText={fieldErrors || ""}
        />
      )}
      renderOption={(props, option) => (
        // Usa un identificatore univoco per la chiave, ad esempio l'ID dell'opzione
        <li {...props} key={option.id || option.label}>
          {option.label}
        </li>
      )}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip label={option.label} {...getTagProps({ index })} />
        ))
      }
    />
  );
};

export default AutocompleteMultipleLookup;
